









import { Component, Vue, Prop } from 'vue-property-decorator';

@Component<Loader>({
  //
})
export default class Loader extends Vue {
  @Prop({ default: '' }) protected title!: string;

  @Prop({ default: '128' }) protected size!: LoaderSize;

  public mounted() {
    //
  }
}

type LoaderSize = '16' | '24' | '32' | '48' | '60' | '128';

